// 账号注销流程 - 跨步骤共享状态
const defaultForm = () => ({
  userName: "", // 注销账号名（接口 userName）
  reasonType: "", // 注销原因枚举（接口 reasonType）
  reasonLabel: "", // 注销原因展示文案（picker 回显用）
  reason: "", // 其他原因（reasonType === 'other' 时必填，接口 reason）
  idCardName: "", // 姓名（接口 idCardName）
  idCardNum: "", // 身份证（接口 idCardNum）
});

const state = {
  closeToken: "", // 注销专用临时凭证，30 分钟有效
  userId: "", // 用户 ID
  telNum: "", // 短信登录时用户输入的手机号
  telMasked: "", // 脱敏手机号
  idCardBound: false, // 是否已绑定实名信息
  latestCloseApplyStatus: null, // 最近一次注销申请状态（0 审核中）
  latestCloseApplyTime: "", // 最近一次注销申请时间
  form: defaultForm(),
  result: {
    applyTime: "", // 申请时间
    expireTime: "", // 审核到期时间（申请日 + auditDays）
    auditDays: 0, // 审核天数（接口固定 15）
  },
};

const mutations = {
  // 登录成功后写入会话凭证
  SET_SESSION(state, { closeToken, userId, telNum } = {}) {
    state.closeToken = closeToken || "";
    if (userId !== undefined) state.userId = userId;
    if (telNum) state.telNum = telNum;
  },
  // 登录响应里的账号信息（接口字段为下划线命名）
  SET_ACCOUNT_INFO(state, info = {}) {
    if (info.tel_masked) state.telMasked = info.tel_masked;
    if (info.id_card_bound !== undefined) state.idCardBound = info.id_card_bound;
    if (info.latest_close_apply_status !== undefined) {
      state.latestCloseApplyStatus = info.latest_close_apply_status;
    }
    if (info.latest_close_apply_time !== undefined) {
      state.latestCloseApplyTime = info.latest_close_apply_time;
    }
    // 预填注销账号名
    state.form = {
      ...state.form,
      userName: info.user_name || state.form.userName,
    };
  },
  SET_FORM(state, form) {
    state.form = { ...state.form, ...form };
  },
  SET_RESULT(state, result = {}) {
    state.result = { ...state.result, ...result };
  },
  RESET(state) {
    state.closeToken = "";
    state.userId = "";
    state.telNum = "";
    state.telMasked = "";
    state.idCardBound = false;
    state.latestCloseApplyStatus = null;
    state.latestCloseApplyTime = "";
    state.form = defaultForm();
    state.result = { applyTime: "", expireTime: "", auditDays: 0 };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
